import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { CORE_ROUTE } from "@obg/ngx.core";
import { ConfigService } from "@obg/ngx.global";

import { Consents } from "./marketing-settings/marketing-settings.model";

@Injectable({
	providedIn: "root",
})
export class DataProtectionConfigService {
	constructor(private config: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getMarketingSettingsEndpoint(): string {
		return this.config.get(
			(x) => x.common.dataProtection.dataProtectionEndpoints!.customerConsents,
			"v1/current-customer-consents"
		);
	}

	getMarketingSettingsEndpointV2(): string {
		return this.config.get(
			(x) => x.common.dataProtection.dataProtectionEndpoints!.customerConsents,
			"v2/current-customer-consents"
		);
	}

	getGdprEnabledCountriesEndpoint(): string {
		return this.config.get(
			(x) => x.common.dataProtection.dataProtectionEndpoints!.gdprEnabledCountries,
			"v1/customer-consents/countries"
		);
	}

	getCookieExpiryYears(): number {
		return this.config.get((x) => x.common.dataProtection.cookieExpiryYears, 2);
	}

	getCookieConsentDisabled(): boolean {
		return this.config.get((x) => x.common.dataProtection.cookieConsentDisabled, false);
	}

	getMarketingConsentDisabled(): boolean {
		return this.config.get((x) => x.common.dataProtection.marketingConsentDisabled, false);
	}

	getGroupMarketingDisabled(): boolean {
		return this.config.get((x) => x.common.dataProtection.groupMarketingConsentDisabled, false);
	}

	getEnableOnlyBrandMarketingConsentUpdate(): boolean {
		return this.config.get((x) => x.common.dataProtection.enableOnlyBrandMarketingConsentUpdate, false);
	}

	getDefaultMarketingConsents(): Consents {
		return this.config.get((x) => x.common.dataProtection.defaultMarketingConsents, {
			brandMarketing: false,
			cookie: false,
			groupMarketing: false,
			thirdParty: false,
		}) as Consents;
	}

	getCookieConsentDisabledRoutes(): string[] {
		return this.config.get(
			(x) => x.common.dataProtection.cookieConsentDisabledRoutes,
			[CORE_ROUTE.cookieSettings, CORE_ROUTE.registration.register, CORE_ROUTE.auth.login]
		);
	}

	getCookieConsentAutomaticDeclineRoutes(): string[] {
		return this.config.get(
			(x) => x.common.dataProtection.cookieConsentAutomaticDeclineRoutes,
			[CORE_ROUTE.cookieSettings]
		);
	}

	getHideGroupConsentCountries(): string[] {
		return this.config.get((x) => x.common.dataProtection.hideGroupConsentCountries, []);
	}

	getOneTrustEnabledCountries(): string[] {
		return this.config.get(
			(x) => x.common.dataProtection.oneTrustEnabledCountries,
			[
				"AT",
				"BE",
				"BG",
				"CO",
				"CY",
				"CZ",
				"DE",
				"DK",
				"EE",
				"ES",
				"FI",
				"FR",
				"GB",
				"GR",
				"HU",
				"HR",
				"IE",
				"IT",
				"LT",
				"LU",
				"LV",
				"MT",
				"NL",
				"PL",
				"PT",
				"RO",
				"SE",
				"SI",
				"SK",
				"NO",
				"IS",
				"LI",
				"CW",
				"CA",
				"AR",
				"MX",
				"PE",
				"BR",
			]
		);
	}

	getOneTrustCountryCheckIsSkipped(): boolean {
		return this.config.get((x) => x.common.oneTrust.skipEnabledCountriesCheck, false);
	}
}
